module.exports = __webpack_public_path__ + "static/Edge-Growth-e401ea6ce7eea641949ab98101ce29c3.png";